import * as React from "react";
import { styled } from "@mui/material/styles";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputBase from "@mui/material/InputBase";
import { Typography } from "antd";
import { useDispatch } from "react-redux";
import {
  updatePaymentStatus,
  updatePaymentStatusSuper,
} from "../../dux/bookingRecords";
import { isAuthorized } from "../../helpers/sessionStorageHelper";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 12,
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

export default function CustomizedSelects({
  defaultStatus,
  bookingId,
  remainingAmount,
  handler,
}) {
  const dispatch = useDispatch();
  const [paymentStatus, setPaymentStatus] = React.useState(defaultStatus);

  // keep local state in sync if parent changes the status externally
  React.useEffect(() => {
    setPaymentStatus(defaultStatus);
  }, [defaultStatus]);

  const onChange = async (e) => {
    e.stopPropagation();
    const next = e.target.value;
    setPaymentStatus(next);

    // pick action by role
    if (isAuthorized("SUPER_ADMIN")) {
      await dispatch(updatePaymentStatusSuper({ bookingId, status: next }));
    } else {
      await dispatch(updatePaymentStatus({ bookingId, status: next }));
    }

    // refresh parent list/UI once the update is done
    handler();
  };

  // text-only for SUCCESS
  if (defaultStatus === "SUCCESS" || defaultStatus === "CANCELLED") {
    return (
      <Typography
        onClick={(e) => e.stopPropagation()}
        style={{ cursor: "default" }}
      >
        {defaultStatus}
      </Typography>
    );
  }

  // who can change?
  const canChangeStatus =
    !isAuthorized("ADMIN_VIEW_ONLY") &&
    (remainingAmount > 0 ||
      isAuthorized("SUPER_ADMIN") ||
      (isAuthorized("ADMIN") && defaultStatus === "PARTIAL"));

  if (!canChangeStatus) {
    return (
      <Typography
        onClick={(e) => e.stopPropagation()}
        style={{ cursor: "default" }}
      >
        {defaultStatus}
      </Typography>
    );
  }

  return (
    <FormControl variant="standard" onClick={(e) => e.stopPropagation()}>
      <Select
        labelId="payment-status-select-label"
        id="payment-status-select"
        value={paymentStatus}
        input={<BootstrapInput />}
        onChange={onChange}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <MenuItem value="PARTIAL">PARTIAL</MenuItem>
        <MenuItem
          value="FULLY_PAID"
          disabled={
            defaultStatus === "FULLY_PAID" && !isAuthorized("SUPER_ADMIN")
          }
        >
          FULLY PAID
        </MenuItem>
      </Select>
    </FormControl>
  );
}
